module.exports = __webpack_public_path__ + "img/chevron-up.7091bc1b.svg";